export function openFileInNewTab(url) {
    if (url) window.open(url, "_blank");
}


// WEBPACK FOOTER //
// ./src/utils/helperFunc.js